import {
  getHistoryValueFromStore,
  setHistoryValueFromStore,
  createHistoryStore,
  enableHistoryFeature
} from '../../../plugins/history'

// indexDB库名
const SELECT_HISTORT_STORE_NAME = 'KYE_SELECT_HISTORT_STORE_NAME'

// props
const HISTORY_FEATURE_ID_KEY = 'historyFeatureId'
const ENABLE_HISTORY_FEATURE_KEY = 'enableHistoryFeature'
const HISTORY_PRIORITY_ELEVATION = 'historyPriorityElevation'
const HISTORY_PROPS = {
  [HISTORY_FEATURE_ID_KEY]: String, // 唯一值
  [ENABLE_HISTORY_FEATURE_KEY]: { // 是否开启历史功能。全局开关 > 路由开关 > 组件开关
    type: Boolean,
    default: false
  },
  [HISTORY_PRIORITY_ELEVATION]: { // 是否开启历史功能。全局开关 > 路由开关 > 组件开关
    type: Boolean,
    default: false
  },
}

// 创建属于select的数据库
const historyStore = createHistoryStore({
  storeName: SELECT_HISTORT_STORE_NAME
})

export default {
  props: HISTORY_PROPS,
  mounted () {
    const historyFeatureId = this.$props[HISTORY_FEATURE_ID_KEY] || ''
    // 前置判断是否开启历史功能, 无ID时也不生效
    if (!enableHistoryFeature(this.$props[ENABLE_HISTORY_FEATURE_KEY]) || !historyFeatureId) {
      return
    }
    const multiple = this.$props.multiple
    // 公共参数
    const commonPamras = {
      historyFeatureId: historyFeatureId + (multiple ? '_array' : '_string'),
      historyStore
    }

    // 数据变化时，存储到数据库。
    this.$watch('value', (value) => {
      setHistoryValueFromStore(commonPamras, {
        value,
        selectedLabel: multiple ? this.selected.map(({label, value, currentLabel, currentValue}) => ({label, value, currentLabel, currentValue})) : this.selected.currentLabel
      })
    })
    const hasDefaultModelValue = multiple ? (this.$props.value && this.$props.value.length) : !!this.$props.value
    if (hasDefaultModelValue && !this.$props[HISTORY_PRIORITY_ELEVATION]) {
      // 如果有默认值就阻止下面的历史搜索赋值，默认值的优先级最高，前提是未提升历史的优先级
      return
    }
    getHistoryValueFromStore(commonPamras, (result) => {
      const { value, selectedLabel } = result || {}
      const defaultValue = multiple ? [] : ''
      this.$emit('input', value || defaultValue)
      this.$emit('change', value || defaultValue)
      // 存在数据的时候才处理 selected 和 cachedOptions ，防止这里赋值之后，立马执行下面的watch，但是selected又不存在值。导致，selectedLabel存储的是同一个值。
      // el-select源码的getOption内部存在判断，不存在 cachedOptions 时，则使用value作为 currentLabel的值。
      // 而 cachedOptions则是在 option.vue组件创建时添加进去的。
      if (multiple) {
        if (Array.isArray(value) && value.length) {
          // 两个都不存在的时候才添加，防止出现错误。
          if (!this.cachedOptions.length && !this.options.length) {
            this.cachedOptions = selectedLabel
            this.selected = selectedLabel
          }
        }
      } else {
        if (value) {
          // 两个都不存在的时候才添加，防止出现错误。
          if (!this.cachedOptions.length && !this.options.length) {
            const item = {
              value,
              currentLabel: selectedLabel
            }
            this.cachedOptions = [item]
            this.selected = item
          }
        }
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-select/mixins/history.js